export const UPDATE_CD_PROP = 'UPDATE_CONTRACTING_DASHBOARD_PROP';

export const GETTING_CONTRACTING_DASHBOARD = 'GETTING_CONTRACTING_DASHBOARD';
export const GOT_CONTRACTING_DASHBOARD = 'GOT_CONTRACTING_DASHBOARD';

export const GETTING_CONTRACTING_YEARS = 'GETTING_CONTRACTING_YEARS';
export const GOT_CONTRACTING_YEARS = 'GOT_CONTRACTING_YEARS';

export const INIT_DASHBOARD = '{contracting} INIT_DASHBOARD';
export const LOAD_DASHBOARD = '{contracting} LOAD_DASHBOARD';
export const UPDATE_WIDGET_DATA = '{contracting} UPDATE_DASHBOARD_WIDGET_DATA';

export const UPDATE_GLOBAL_LIST_FILTER = '{contracting} UPDATE_GLOBAL_LIST_FILTER';
export const CLEAR_GLOBAL_LIST_FILTER = `{contracting} CLEAR_GLOBAL_LIST_FILTER`;

export const RESET_GLOBAL_DASHBOARD_FILTER = '{contracting} RESET_GLOBAL_DASHBOARD_FILTER';
export const LOAD_FOLDERS = '{contracting} LOAD_FOLDERS_FOR_DASHBOARD_FILTER';

export const UPDATE_GLOBAL_FILTER = '{contracting} UPDATE_GLOBAL_FILTER';

export const UPDATE_WIDGET_FILTER = '{contracting} UPDATE_DASHBOARD_WIDGET_FILTER';



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/__storeFiles__/constants.js